import * as ACTION from 'actions';

export const loadingCount = (state=0, action) => {
    switch (action.type) {
        case ACTION.ADD_LOADING_COUNT:
            return state+1;
        case ACTION.DELETE_LOADING_COUNT:
            return state-1;
        default:
            return state;
    }
};